'use strict';

import * as Onyx from '../lib/onyx.min.js';

const TEXTURE_SIZE = 128;
const TEXTURE_SCALE = 8;
const TILE_COUNT = 1;
const SPEED = 0.35;

const VERTEX_SHADER = `
    precision mediump float;

    attribute vec3 aVertexPosition;

    uniform float iTime;

    varying float vTime;

	void main() {
        vTime = iTime * 1000.0 * ${(SPEED).toFixed(2)};

        gl_Position = vec4(aVertexPosition, 1.0);
	}
`;

const FRAG_SHADER = `
    precision highp float;

    #define TAU 6.28318530718
    #define MAX_ITER 4

    varying float vTime;

    void main(void) {
        // uv should be the 0-1 uv of texture...
        vec2 uv = (gl_FragCoord.xy / ${(TEXTURE_SIZE / TILE_COUNT).toFixed(2)});
        
        vec2 p = mod(uv*TAU, TAU)-250.0;
        vec2 i = vec2(p);
        float c = 1.0;
        float inten = .5;
    
        for (int n = 0; n < MAX_ITER; n++) 
        {
            float t = vTime * (1.0 - (3.5 / float(n+1)));
            i = p + vec2(cos(t - i.x) + sin(t + i.y), sin(t - i.y) + cos(t + i.x));
            c += 1.0/length(vec2(p.x / ((sin(i.x+t) * 100.0)/inten),p.y / ((cos(i.y+t) * 100.0)/inten)));
        }
        c /= float(MAX_ITER);
        c = 1.17-pow(c, 1.4);
        vec3 colour = vec3(pow(abs(c), 3.0));
        colour = clamp(colour - vec3(0.74, 0.20, 0.18), 0.0, 1.0);
        
        gl_FragColor = vec4(colour, 1.0);
    }
`;

export default class FrameBufferTexture2DCaustic extends Onyx.FrameBufferTexture2D {
	constructor(name = "") {
        super(name, {width: TEXTURE_SIZE, height: TEXTURE_SIZE, scale: TEXTURE_SCALE});
        
        // this.shaderAttributes = ["aVertexPosition", "aTextureCoord"];
        // this.shaderUniforms = ["iTime"];
        
        this.vertexShader = VERTEX_SHADER;
        this.fragmentShader = FRAG_SHADER;
	}
    
    buildProgram(){

    }
}